"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Dashboard_1 = require("../../../components/Pages/Dashboard/Dashboard");
var Home = function () {
    return React.createElement(Dashboard_1.default, null);
};
exports.default = Home;
